export const breadcrumbs = [
  {
    text: "Главная",
    disabled: false,
    href: "/",
  },
  {
    text: "Справочники: Справочник архивов",
    disabled: true,
    href: "breadcrumbs_link_1",
  },
];
